<dx-data-grid [dataSource]="coachSessions"
              [allowColumnResizing]="true"
              [allowColumnReordering]="true"
              [wordWrapEnabled]="true"
              [rowAlternationEnabled]="true"
              [hoverStateEnabled]="true"
              [showRowLines]="true"
              [showBorders]="true"
              [stateStoring]="dxGridWrapperHelper.stateStoringOptions"
              (onInitialized)="onGridInitialized($event)"
              noDataText="No coaching sessions have been booked yet">
    <dxo-data-grid-column-fixing [enabled]="true"></dxo-data-grid-column-fixing>
    <dxo-data-grid-column-chooser [enabled]="true"></dxo-data-grid-column-chooser>
    <dxo-data-grid-paging [pageSize]="10"></dxo-data-grid-paging>
    <dxo-data-grid-pager [showPageSizeSelector]="true"
                         [allowedPageSizes]="[10, 25, 50, 100]"></dxo-data-grid-pager>
    <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
    <dxo-data-grid-header-filter [visible]="true"></dxo-data-grid-header-filter>

    @if (showInternalData) {
        <dxi-data-grid-column dataField="coachSessionId"
                              caption="Id"
                              dataType="number"
                              alignment="left"
                              [width]="60"></dxi-data-grid-column>
    }
    <dxi-data-grid-column dataField="invoice.invoiceString"
                          caption="Invoice #"
                          dataType="string"
                          alignment="left"></dxi-data-grid-column>
    <dxi-data-grid-column dataField="invoice.date"
                          dataType="date"
                          caption="Invoice Date"
                          [format]="dateFormat"
                          sortOrder="desc"
                          alignment="left"></dxi-data-grid-column>
    <dxi-data-grid-column caption="Session Type"
                          alignment="left"
                          dataType="string"
                          dataField="type"
                          [calculateCellValue]="calculateTypeCellValue"></dxi-data-grid-column>
    <dxi-data-grid-column dataField="invoice.total"
                          dataType="number"
                          caption="Cost"
                          format="currency"
                          alignment="left"
                          [width]="80"></dxi-data-grid-column>
    @if (personTemplate) {
        <dxi-data-grid-column cellTemplate="personCellTemplate"
                              caption="Person"
                              dataField="person.fullName"
                              dataType="string"
                              alignment="left"></dxi-data-grid-column>
    }
    <dxi-data-grid-column cellTemplate="textCellTemplate"
                          dataField="description"
                          dataType="string"
                          caption="Issue"
                          alignment="left"></dxi-data-grid-column>
    <dxi-data-grid-column cellTemplate="ratingCellTemplate"
                          dataField="feedbackRating"
                          dataType="number"
                          [caption]="showInternalData ? 'Session Rating' : 'Your Session Rating'"
                          alignment="left"></dxi-data-grid-column>
    <dxi-data-grid-column cellTemplate="textCellTemplate"
                          dataField="feedbackComment"
                          dataType="string"
                          [caption]="showInternalData ? 'Session Comment' : 'Your Session Comment'"
                          alignment="left"></dxi-data-grid-column>
    <dxi-data-grid-column cellTemplate="statusCellTemplate"
                          [calculateCellValue]="calculateStatusCellValue"
                          caption="Status"
                          dataType="string"
                          dataField="status"
                          alignment="left"
                          [width]="150"></dxi-data-grid-column>
    @if (coachTemplate && showInternalData) {
        <dxi-data-grid-column cellTemplate="coachCellTemplate"
                              caption="Coach"
                              dataField="practitioner.person.fullName"
                              dataType="string"
                              alignment="left"></dxi-data-grid-column>
    }
    @if (actionTemplate && showInternalData) {
        <dxi-data-grid-column caption=""
                              dataType="string"
                              dataField="actions"
                              cellTemplate="actionsCellTemplate"
                              [allowSorting]="false"
                              [allowReordering]="false"
                              [allowHiding]="false"
                              [allowFiltering]="false"
                              [allowResizing]="false"
                              [fixed]="true"
                              fixedPosition="right"
                              [width]="50"></dxi-data-grid-column>
    }

    <div *dxTemplate="let item of 'textCellTemplate'">
        <p style="white-space: pre-line">{{ item.value }}</p>
    </div>

    <div *dxTemplate="let item of 'ratingCellTemplate'">
        @if (!!item.value) {
            <adapt-rating-stars [rating]="item.value"
                                disabled
                                compact></adapt-rating-stars>
        } @else {
            N/A
        }
    </div>

    <div *dxTemplate="let item of 'statusCellTemplate'"
         class="d-flex align-items-center"
         [adaptTooltip]="getStatusTooltip(item.data)">
        <div class="status badge"
             [ngClass]="item.data.statusMetadata.badgeClass">
            {{ item.value }}
        </div>
        @if (item.data.status === CoachSessionStatus.Paid) {
            <span class="fas fa-xl fa-exclamation-triangle text-warning ms-1"></span>
        }
    </div>

    <div *dxTemplate="let item of 'personCellTemplate'">
        <ng-container [ngTemplateOutlet]="personTemplate"
                      [ngTemplateOutletContext]="{ $implicit: item.data.person }"></ng-container>
    </div>

    <div *dxTemplate="let item of 'coachCellTemplate'">
        <ng-container [ngTemplateOutlet]="coachTemplate"
                      [ngTemplateOutletContext]="{ $implicit: item.data.practitioner }"></ng-container>
    </div>

    <div *dxTemplate="let item of 'actionsCellTemplate'">
        <ng-container [ngTemplateOutlet]="actionTemplate"
                      [ngTemplateOutletContext]="{
                $implicit: item.data,
                updated: actionsUpdated,
            }"></ng-container>
    </div>
</dx-data-grid>
